import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "whitespace-nowrap inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover-elevate",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow-xs",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow-xs",
        outline: "text-foreground border [border-color:var(--badge-outline)]",
        hot: "border-transparent bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-sm status-badge-enter",
        warm: "border-transparent bg-gradient-to-r from-amber-500 to-yellow-500 text-amber-900 shadow-sm status-badge-enter dark:text-amber-200",
        cool: "border-transparent bg-gradient-to-r from-blue-400 to-cyan-500 text-white shadow-sm status-badge-enter",
        success: "border-transparent bg-gradient-to-r from-emerald-500 to-green-500 text-white shadow-sm status-badge-enter",
        active: "border-transparent bg-primary/90 text-primary-foreground shadow-sm",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
